import React from 'react';
import Modal from './Modal';
import { AlertTriangle } from 'lucide-react';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirmar Ação', 
  message = 'Tem certeza de que deseja continuar?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  variant = 'primary'
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm" contentAlignCenter>
      <div className="text-center">
        <div className="mb-4 flex items-center justify-center">
          <AlertTriangle className={variant === 'danger' ? 'text-red-600 w-12 h-12' : 'text-blue-600 w-12 h-12'} />
        </div>
        <p className="text-secondary mb-6">{message}</p>
        <div className="flex items-center justify-center gap-3">
          <button className="btn btn-outline" onClick={onClose} aria-label={cancelText}>{cancelText}</button>
          <button className={`btn ${variant === 'danger' ? 'btn-danger' : 'btn-primary'}`} onClick={handleConfirm} aria-label={confirmText}>{confirmText}</button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
